const digCode = {
  "000": "0",
  "100": "1",
  "010": "2",
  "110": "3",
  "001": "4",
  "101": "5",
  "011": "6",
  "111": "7"
};

export const formDigCode = propValue => {
  let digRawCode =
    (propValue.fasteners.orderCode ? propValue.fasteners.orderCode : "") +
    (propValue.externalBrakeRelease.orderCode
      ? propValue.externalBrakeRelease.orderCode
      : "") +
    (propValue.throttleValve.orderCode
      ? propValue.throttleValve.orderCode
      : "");

  return digCode[digRawCode];
};



// WEBPACK FOOTER //
// ./src/common/formDigCode.js